import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActionHandlerService } from 'src/app/services/action-handler.service';

@Component({
  selector: 'app-icon-stack-button',
  templateUrl: './icon-stack-button.component.html',
  styleUrls: ['./icon-stack-button.component.scss']
})
export class IconStackButtonComponent implements OnInit, AfterViewInit {
  private _mode = '';
  public icons: Array<number> = [];

  @HostBinding('attr.title') title: string = '';
  @ViewChild('button') button: ElementRef<HTMLButtonElement>;
  @Input() set mode(btnMode: string) {
    this._mode = btnMode;
    this.button?.nativeElement.classList.toggle('btn-' + btnMode, true);
  }
  private _isOn = false;
  @Input()
  public get isOn(): boolean {
    return this._isOn;
  }
  public set isOn(isIt: boolean) {
    if (this._isOn === isIt) return;
    this._isOn = isIt;
    if (!!this.action) {
      this.actions.HandleAction(this.action, { toggled: this._isOn, value: (this._isOn ? this.onValue : this.offValue) })
    }
    this.isOnChange.emit(this._isOn);
  }
  @Output()
  public isOnChange = new EventEmitter<boolean>();

  private _toggleable = false;
  public set toggleable(isIt: boolean) {
    if (this._toggleable === isIt) return;
    this._toggleable = isIt;
    this.toggleableChange.emit(this._toggleable);
  }
  public get toggleable(): boolean {
    return this._toggleable;
  }
  public toggleableChange = new EventEmitter<boolean>();

  private action: string = '';
  public onValue: string = '';
  public offValue: string = '';

  constructor(private domNode: ElementRef, private actions: ActionHandlerService) {

  }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    window.requestAnimationFrame(() => {
      const style = getComputedStyle(this.domNode.nativeElement);
      if (!this._mode) {
        this._mode = style.getPropertyValue('--button-mode');
        if (!this._mode) this._mode = 'primary';
      }
      this.action = style.getPropertyValue('--action');
      if (this.action !== '') {
        this.title = this.actions.GetActionAlt(this.action);
      }
      if (this.title === '') {
        const title = style.getPropertyValue('--button-title');
        this.title = title.trim().substring(1, title.length - 1);

      }
      this.offValue = style.getPropertyValue('--on-value');
      this.onValue = style.getPropertyValue('--on-value');
      this.mode = this._mode;
      this._toggleable = style.getPropertyValue('--toggleable') === 'true';
      const num = getComputedStyle(this.domNode.nativeElement).getPropertyValue('--icon-count');
      const count = Number(num);
      if (isNaN(count)) return;
      this.icons = Array(count).fill(1);
    })

  }
  HandleClick() {
    if (this._toggleable) {
      this.isOn = !this.isOn;
      return;
    }
    this.actions.HandleAction(this.action)

  }
}
